// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/personal/file/index.less
// module id = 2271
// module chunks = 0